
import React, { Component, Fragment, useEffect, useState, useContext } from "react";
import { SessionContext } from "../../../context/SessionProvider";



import BiCheckBox from '../../uic/controls/BiCheckBox';
import BiTextBox from '../../uic/controls/BiTextBox';
import BiLabel from '../../uic/controls/BiLabel';

import BiFormTable from '../../uic/formTable/BiFormTable';
import BiFormRow from '../../uic/formTable/BiFormRow';
import BiFormCell from '../../uic/formTable/BiFormCell';
import BiFormSection from '../../uic/formTable/BiFormSection';
import BiCheckBoxList from "../../uic/controls/BiCheckBoxList";
import BiTextArea from "../../uic/controls/BiTextArea";

const StatusObrazca = ({
    status

}) => {



    const statusObrazca = () => {
        if (status == 1) {
            return <BiLabel icon="fas fa-pen-to-square"><span style={{ color: "green" }} >Vpisan</span></BiLabel>
        }
        else if (status == 2) {
            return <BiLabel icon="fas fa-file"><span style={{ color: "orange" }} >Prevzet</span></BiLabel>
        }
        else if (status == 3) {
            return <BiLabel icon="fas fa-gears"><span style={{ color: "#004c99" }} >V obdelavi</span></BiLabel>
        }
        else if (status == 4) {
            return <BiLabel icon="fas fa-check"><span style={{ color: "green" }} >Dopolnitev</span></BiLabel>
        }
        else if (status == 5) {
            return <BiLabel icon="fas fa-circle-xmark"><span style={{ color: "red" }} >Zavrnjen</span></BiLabel>
        }
        else if (status == 6) {
            return <BiLabel icon="fas fa-circle-xmark"><span style={{ color: "black" }} >Po pošti</span></BiLabel>
        }
        else if (status == 7) {
            return <BiLabel icon="fas fa-circle-xmark"><span style={{ color: "blue" }} >V pisarni</span></BiLabel>
        }
        else if (status == 8) {
            return <BiLabel icon="fas fa-check"><span style={{ color: "darkmagenta" }} >Po pošti potrjen</span></BiLabel>
        }
        else if (status == 9) {
            return <BiLabel icon="fas fa-check"><span style={{ color: "darkgreen" }} >V podpisovanju</span></BiLabel>
        }
        else if (status == 10) {
            return <BiLabel icon="fa-regular fa-circle-stop"><span style={{ color: "darkgreen" }} >Zaključen</span></BiLabel>
        }
        else if (status == 11) {
            return <BiLabel icon="fa-solid fa-outdent"><span style={{ color: "darkred" }} >Odstop</span></BiLabel>
        }
    }


    return (
        <Fragment>
            {statusObrazca()}
        </Fragment>
    );
}

export default StatusObrazca;